import React, { useCallback, useState } from 'react'
import { toast } from 'react-toastify'
import { useReceivement } from '../../../../../../hooks/useReceivement'
import { useRouteToReceivement } from '../../../../../../hooks/useRouteToReceivement'
import { proceedToNextStep } from '../../../../../../services/receivement/receivementService'
import * as S from './FinishButton.styles'

const FinishButton = ({ disabled, receivementId }) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false)
  const { routeToReceivement } = useRouteToReceivement()
  const { operatorBadge } = useReceivement()

  const handleClick = useCallback(async () => {
    setIsButtonDisabled(true)

    const result = await proceedToNextStep(operatorBadge, receivementId)
    if (!result.isOk) {
      toast.error('Falha ao finalizar o atendimento!')
      setIsButtonDisabled(false) 
      return
    }

    routeToReceivement({
      receivementId: receivementId,
      receivementStatus: result.data.status
    })
  }, [operatorBadge, receivementId, routeToReceivement])

  return (
    <S.Button
      disabled={disabled || isButtonDisabled}
      aria-label="Finalizar recebimento"
      onClick={handleClick}
    >
      Finalizar recebimento
    </S.Button>
  )
}

export default FinishButton
